'use client'

import React, { useReducer, useContext } from 'react'

import reducer from './reducer'
import axios from 'axios'
import {
    HOME_STYLE,
    STATS,
    SERVICES,
    SLIDESHOW,
    ABOUT_BANNER,
    TEAM_MEMBERS,
    TESTIMONIALS,
} from './actions'

const initialState = {
    // Home Style 
    header_color: '',
    header_text_color: '',
    footer_color: '',
    footer_text_color: '',
    logo: '',
    monogram: '',

    // Stats
    happy_clients: '',
    no_of_projects_done: '',
    team_members: '',
    
    //Images and TagLines
    slideshow_images: [],
    
    //Services
    services: [],
    
    //About
    about_page_image_url: '',
    about_page_main_text: '',

    // Team
    team_members: [],

    // Projects
    testimonials: [],
}

const AppContext = React.createContext()

const AppProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState)
    const toggleHomeStyle = async () => {
        try {
            const response = await axios.get('/api/home')
            dispatch({ type: HOME_STYLE, payload: response.data })
        }
        catch (error){
            console.log(error)
        }
    }
    const toggleStats = async () => {
        try {
            const response = await axios.get('/api/home')
            dispatch({ type: STATS, payload: response.data })
        }
        catch (error){
            console.log(error)
        }
    }
    const toggleServices = async () => {
        try {
            const response = await axios.get('/api/home')
            dispatch({ type: SERVICES, payload: response.data })
        }
        catch (error){
            console.log(error)
        }
    }
    const toggleSlideshow = async () => {
        try {
            const response = await axios.get('/api/home')
            dispatch({ type: SLIDESHOW, payload: response.data })
        }
        catch (error){
            console.log(error)
        }
    }



    const toggleAboutBanner = async () => {
        try {
            const response = await axios.get('/api/about')
            dispatch({ type: ABOUT_BANNER, payload: response.data })
        }
        catch (error){
            console.log(error)
        }
    }
    const toggleTeamMembers = async () => {
        try {
            const response = await axios.get('/api/about')
            dispatch({ type: TEAM_MEMBERS, payload: response.data })
        }
        catch (error){
            console.log(error)
        }
    }

    const toggleTestimonials = async () => {
        try {
            const response = await axios.get('/api/about')
            dispatch({ type: TESTIMONIALS, payload: response.data })
        }
        catch (error){
            console.log(error)
        }
    }
    return (
        <AppContext.Provider value={{ 
            ...state,
            toggleHomeStyle,
            toggleStats,
            toggleServices,
            toggleSlideshow,
            toggleAboutBanner,
            toggleTeamMembers,
            }}>
            {children}
        </AppContext.Provider>
    )
}

const useAppContext = () => {
    return useContext(AppContext)
}

export { AppProvider, initialState, useAppContext }



